import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';


@Component({
    selector: 'app-pharmacy-peek-discard-changes-dialog',
    templateUrl: './pharmacy-peek-discard-changes-dialog.component.html',
    styleUrls: ['./pharmacy-peek-discard-changes-dialog.component.scss'],
    standalone: false
})
export class PharmacyPeekDiscardChangesDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<PharmacyPeekDiscardChangesDialogComponent>,
  ) { }

  ngOnInit(): void {
  }

  closeDialog() {
    this.dialogRef.close({undoChanges : false});
  }

  closeDialogUndo() {
    this.dialogRef.close({undoChanges : true});
  }


}
